var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "web-dropdown--arrow-icon web-dropdown--arrow-icon__open",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5163 14.766C12.2328 15.078 11.7677 15.078 11.4842 14.766L9.11904 12.1665L7.15966 10.0132C6.81893 9.63975 7.05966 9 7.54111 9H11.9999H16.4587C16.9401 9 17.1808 9.63975 16.8408 10.0132L14.8815 12.1665L12.5163 14.766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledArrow);
export default __webpack_public_path__ + "static/media/filledArrow.dc3f727652cc1f01cfbde6c67b112e91.svg";
export { ForwardRef as ReactComponent };